import React, { FC, memo } from 'react';

import { ECustomerType } from '@webtrader/core/api/account/signUp';
import { ACCOUNT_TYPE_OPTIONS } from '@webtrader/core/constants/sign-up';
import { EDataTestId } from '@webtrader/core/constants/test';
import { useTranslation } from '@webtrader/core/i18n';

import ActionSheet, { IActionSheetOption } from '@/components/ActionSheet';

interface IProps {
  value?: ECustomerType;
  disabled?: boolean;
  onSelect: (accountType: ECustomerType) => void;
}

const SignUpFormAccountType: FC<IProps> = ({ value, disabled = false, onSelect }) => {
  const { t } = useTranslation();

  const accountTypeOptions: IActionSheetOption<ECustomerType>[] = ACCOUNT_TYPE_OPTIONS;
  return (
    <ActionSheet<ECustomerType>
      size="default"
      title={t('Account Type')}
      options={accountTypeOptions}
      onChange={onSelect}
      disabled={disabled}
      value={value}
      testID={EDataTestId.SIGN_UP_ACCOUNT_TYPE}
    />
  );
};

export default memo(SignUpFormAccountType);
